// src/features/dashboard/services/employeeStats.service.ts

import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';

import type {
  EmployeeStatsResponse,
} from '../types/employeeStats.types';

type EmployeeStatsPayload = {
  employeeCode: string;
  fromDate: string;
  toDate: string;
};

export const getEmployeeStats = async (
  payload: EmployeeStatsPayload,
): Promise<EmployeeStatsResponse> => {

  const token =
    localStorage.getItem('token') ||
    sessionStorage.getItem('token');

  const response =
    await api.post<EmployeeStatsResponse>(
      ENDPOINTS.EMPLOYEE_KPI_TRENDS,
      payload,
      {
        headers: {
          Authorization:
            `Bearer ${token}`,
        },
      },
    );

  return response.data;
};